import { render, staticRenderFns } from "./ChickensList.vue?vue&type=template&id=6022c0c2&scoped=true"
import script from "./ChickensList.vue?vue&type=script&lang=js"
export * from "./ChickensList.vue?vue&type=script&lang=js"
import style0 from "./ChickensList.vue?vue&type=style&index=0&id=6022c0c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6022c0c2",
  null
  
)

export default component.exports